import mycarsSrpVdp from './utils/mycarsSrpVdp';

export default {
	events: {
		'ddc.link.generic': [...mycarsSrpVdp['ddc.link.generic']],
		widgetUserEvent: [...mycarsSrpVdp.widgetUserEvent]
	}
};
